var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 2.8H2.0625C1.88016 2.8 1.7053 2.72625 1.57636 2.59497C1.44743 2.4637 1.375 2.28565 1.375 2.1C1.375 1.91435 1.44743 1.7363 1.57636 1.60503C1.7053 1.47375 1.88016 1.4 2.0625 1.4H9.625V0.7C9.625 0.514348 9.55257 0.336301 9.42364 0.205025C9.2947 0.0737498 9.11984 0 8.9375 0L1.375 0C1.01033 0 0.660591 0.1475 0.402728 0.410051C0.144866 0.672601 0 1.0287 0 1.4V12.6C0 13.37 0.61875 14 1.375 14H9.625C9.98967 14 10.3394 13.8525 10.5973 13.5899C10.8551 13.3274 11 12.9713 11 12.6V3.5C11 3.31435 10.9276 3.1363 10.7986 3.00503C10.6697 2.87375 10.4948 2.8 10.3125 2.8H5.5V8.4L4.125 7L2.75 8.4V2.8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.53fd53276f428fa6b8bdda827b410489.svg";
export { ForwardRef as ReactComponent };